import { createGrid } from "ag-grid-enterprise";
import { AgChartsCommunityModule } from "ag-charts-community";
import * as Solr from "../../../../3x1010/Solr.js";

// importa il css di ag-grid
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import { AG_GRID_LOCALE_IT } from "@ag-grid-community/locale";
import QueryResults from "./QueryResults";
import Pqp from "../../../../3x1010/Pqp.js";
import FieldRender from "./FieldRender.js";

export default class FilmografiaDetails {
  eGui;

  init(params) {
    this.params = params;
    const div = jQuery("#template-filmografia-details").clone();
    div.removeAttr("id");
    this.eGui = div[0];
    const ct = jQuery(this.eGui);
    this.ct = ct;
    this.schema = new Solr.Schema("FILMOGRAFIA_coll");
    this.fr = new FieldRender("FILMOGRAFIA_coll");

    this.createFilmografiaGrid();
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    return false;
  }

  createFilmografiaGrid() {
    this.rows = [];
    const films = this.params.data.Filmografia;
    if (films.length === 0) {
      return;
    }

    console.log(films);

    const gridOptions = {
      columnDefs: this.getColumns(),
      rowModelType: "clientSide",
      localeText: AG_GRID_LOCALE_IT,
      rowData: films,
      domLayout: "autoHeight",
      detailRowAutoHeight: true,
      suppressCellFocus: true,
      suppressRowHoverHighlight: true,
      suppressRowVirtualisation: true,
      suppressRowTransform: true,
      defaultColDef: {
        wrapText: true, // Testo a capo automaticamente
        autoHeight: true, // Altezza automatica delle righe per il contenuto
        resizable: true, // Tutte le colonne possono essere ridimensionate
        sortable: false, // Ordinamento abilitato per tutte le colonne
        filter: false, // Filtro abilitato per tutte le colonne
        flex: 1, // Assegna a tutte le colonne flex 1
        suppressMenu: true, // Rimuove il menu (i tre puntini) da tutte le colonne
      },
    };

    this.agGrid = createGrid(jQuery(".js-grid-filmografia", this.ct).get(0), gridOptions);
  }

  getColumns() {
    const columnDefs = [
      // Titolo
      this.fr.fieldList("label", "Titolo", 2, this.params.context.customPayload.callback, "FILMOGRAFIA_titolo", null, null, null, null, null, { type: QueryResults.SCHEDA_TYPE_FILM, prop: "id" }),
      // Produzione
      this.fr.fieldList("produzione_scheda_PRD", "Produzione", 2),
      // Data
      this.fr.fieldList("cronologia_datazione_scheda_DT", "Data", 1, null, null, "data_DTI"),
      // Regista
      this.fr.fieldList("registi", "Regista", 2, this.params.context.customPayload.callback, "FILMOGRAFIA_regista", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "registi.rel_entity_id", key: "rel_entity_id" }),
      // Interpreti
      this.fr.fieldList("interpreti", "Interpreti", 2, this.params.context.customPayload.callback, "FILMOGRAFIA_interprete", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "interpreti.rel_entity_id", key: "rel_entity_id" }),
      // Sceneggiatura
      this.fr.fieldList("sceneggatori", "Sceneggiatura", 2, this.params.context.customPayload.callback, "FILMOGRAFIA_sceneggiatore", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "sceneggatori.rel_entity_id", key: "rel_entity_id" }),
      // Scenografia
      this.fr.fieldList("scenografi", "Scenografia", 2, this.params.context.customPayload.callback, "FILMOGRAFIA_scenografo", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "scenografi.rel_entity_id", key: "rel_entity_id" }),
      // Montaggio
      this.fr.fieldList("montatori", "Montaggio", 2, this.params.context.customPayload.callback, "FILMOGRAFIA_montatore", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "montatori.rel_entity_id", key: "rel_entity_id" }),
      // NCNT
      this.fr.fieldPlain("numero_catalogo_generale_NCTN", "NCNT", 1),
    ];
    return columnDefs;
  }

  getField(value) {
    if (!value) {
      return [];
    }
    if (Array.isArray(value)) {
      return value;
    }
    return [value];
  }

  getLabel(name, def) {
    if (QueryResults.READ_COLUMN_HEADER_FROM_SCHEMA) {
      const sch = this.getFieldByNameFromSchema(name);
      if (Pqp.isNullOrEmpty(sch)) {
        return def;
      }
      return sch.Label;
    }
    return def;
  }

  getFieldByNameFromSchema(name) {
    return this.schema.getFieldByName(name);
  }
}

FilmografiaDetails.QUERY_FILMOGRAFIA_titolo = {
  id: "QN1731046792319",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731046792320",
      Field: {
        _path: "/Filmografia",
        _label: "/Filmografia",
        Name: "Filmografia",
        Label: "Filmografia",
        Relation: "FILMOGRAFIA_coll",
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731046792321",
          Field: {
            _path: "/Filmografia/label",
            _label: "/Filmografia/label",
            Name: "label",
            Label: "label",
            Relation: null,
            Flags: 7,
            IsArray: false,
            Type: "text",
          },
          Occurency: "MUST",
          type: "QueryNodeTerm",
          Value: "dummy",
          Compare: "tPHRASEw",
        },
      ],
    },
  ],
  CollectionName: "dummy",
};

FilmografiaDetails.QUERY_FILMOGRAFIA_regista = {
  id: "QN1731061408979",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731061408984",
      Field: {
        _path: "/Filmografia",
        _label: "/Filmografia",
        Name: "Filmografia",
        Label: "Filmografia",
        Relation: "FILMOGRAFIA_coll",
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731061408985",
          Field: {
            _path: "/Filmografia/registi",
            _label: "/Filmografia/registi",
            Name: "registi",
            Label: "registi",
            Relation: null,
            Flags: 7,
            IsArray: true,
            Type: "complex",
          },
          Occurency: "MUST",
          type: "QueryNodeBoolean",
          AdmitExists: true,
          Operator: "AND",
          Clauses: [
            {
              id: "QN1731061408986",
              Field: {
                _path: "/Filmografia/registi/label",
                _label: "/Filmografia/registi/label",
                Name: "label",
                Label: "label",
                Relation: null,
                Flags: 7,
                IsArray: false,
                Type: "text",
              },
              Occurency: "MUST",
              type: "QueryNodeTerm",
              Value: "dummy",
              Compare: "tPHRASEw",
            },
          ],
        },
      ],
    },
  ],
  CollectionName: "dummy",
};

FilmografiaDetails.QUERY_FILMOGRAFIA_interprete = {
  id: "QN1731062928455",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731062928456",
      Field: {
        _path: "/Filmografia",
        _label: "/Filmografia",
        Name: "Filmografia",
        Label: "Filmografia",
        Relation: "FILMOGRAFIA_coll",
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731062928459",
          Field: {
            _path: "/Filmografia/interpreti",
            _label: "/Filmografia/interpreti",
            Name: "interpreti",
            Label: "interpreti",
            Relation: null,
            Flags: 7,
            IsArray: true,
            Type: "complex",
          },
          Occurency: "MUST",
          type: "QueryNodeBoolean",
          AdmitExists: true,
          Operator: "AND",
          Clauses: [
            {
              id: "QN1731062928460",
              Field: {
                _path: "/Filmografia/interpreti/label",
                _label: "/Filmografia/interpreti/label",
                Name: "label",
                Label: "label",
                Relation: null,
                Flags: 7,
                IsArray: false,
                Type: "text",
              },
              Occurency: "MUST",
              type: "QueryNodeTerm",
              Value: "dummy",
              Compare: "tPHRASEw",
            },
          ],
        },
      ],
    },
  ],
  CollectionName: "dummy",
};

FilmografiaDetails.QUERY_FILMOGRAFIA_sceneggiatore = {
  id: "QN1731063123799",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731063123818",
      Field: {
        _path: "/Filmografia",
        _label: "/Filmografia",
        Name: "Filmografia",
        Label: "Filmografia",
        Relation: "FILMOGRAFIA_coll",
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731063123819",
          Field: {
            _path: "/Filmografia/sceneggatori",
            _label: "/Filmografia/sceneggatori",
            Name: "sceneggatori",
            Label: "sceneggatori",
            Relation: null,
            Flags: 7,
            IsArray: true,
            Type: "complex",
          },
          Occurency: "MUST",
          type: "QueryNodeBoolean",
          AdmitExists: true,
          Operator: "AND",
          Clauses: [
            {
              id: "QN1731063123820",
              Field: {
                _path: "/Filmografia/sceneggatori/label",
                _label: "/Filmografia/sceneggatori/label",
                Name: "label",
                Label: "label",
                Relation: null,
                Flags: 7,
                IsArray: false,
                Type: "text",
              },
              Occurency: "MUST",
              type: "QueryNodeTerm",
              Value: "dummy",
              Compare: "tPHRASEw",
            },
          ],
        },
      ],
    },
  ],
  CollectionName: "FOTOTECA_coll",
};

FilmografiaDetails.QUERY_FILMOGRAFIA_scenografo = {
  id: "QN1731063561349",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731063561350",
      Field: {
        _path: "/Filmografia",
        _label: "/Filmografia",
        Name: "Filmografia",
        Label: "Filmografia",
        Relation: "FILMOGRAFIA_coll",
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731063561351",
          Field: {
            _path: "/Filmografia/scenografi",
            _label: "/Filmografia/scenografi",
            Name: "scenografi",
            Label: "scenografi",
            Relation: null,
            Flags: 7,
            IsArray: true,
            Type: "complex",
          },
          Occurency: "MUST",
          type: "QueryNodeBoolean",
          AdmitExists: true,
          Operator: "AND",
          Clauses: [
            {
              id: "QN1731063561352",
              Field: {
                _path: "/Filmografia/scenografi/label",
                _label: "/Filmografia/scenografi/label",
                Name: "label",
                Label: "label",
                Relation: null,
                Flags: 7,
                IsArray: false,
                Type: "text",
              },
              Occurency: "MUST",
              type: "QueryNodeTerm",
              Value: "dummy",
              Compare: "tPHRASEw",
            },
          ],
        },
      ],
    },
  ],
  CollectionName: "dummy",
};

FilmografiaDetails.QUERY_FILMOGRAFIA_montatore = {
  id: "QN1731063561349",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731063561350",
      Field: {
        _path: "/Filmografia",
        _label: "/Filmografia",
        Name: "Filmografia",
        Label: "Filmografia",
        Relation: "FILMOGRAFIA_coll",
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731063561353",
          Field: {
            _path: "/Filmografia/montatori",
            _label: "/Filmografia/montatori",
            Name: "montatori",
            Label: "montatori",
            Relation: null,
            Flags: 7,
            IsArray: true,
            Type: "complex",
          },
          Occurency: "MUST",
          type: "QueryNodeBoolean",
          AdmitExists: true,
          Operator: "AND",
          Clauses: [
            {
              id: "QN1731063561354",
              Field: {
                _path: "/Filmografia/montatori/label",
                _label: "/Filmografia/montatori/label",
                Name: "label",
                Label: "label",
                Relation: null,
                Flags: 7,
                IsArray: false,
                Type: "text",
              },
              Occurency: "MUST",
              type: "QueryNodeTerm",
              Value: "dummy",
              Compare: "tPHRASEw",
            },
          ],
        },
      ],
    },
  ],
  CollectionName: "dummy",
};
